// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.soqtGqqqvTTw6WLCQ6ow {

    display: flex;

    flex-direction: column;

    align-items: center;

    justify-content: center;

    gap: 1rem;

    padding: 1.5rem;

    text-align: center
}

.kwP0PCUwBfWaMCUTojfT {

    height: 165px;

    width: 165px
}

.KiBYUGfbraDxoQDYsylb {

    margin-top: 1rem;

    font-family: Noto Sans;

    font-size: 20px;

    font-weight: 600;

    --tw-text-opacity: 1;

    color: rgb(26 26 26 / var(--tw-text-opacity, 1))
}

.uMZDLazix2oFGedLw5QB {

    font-family: Noto Sans;

    font-size: 16px;

    font-weight: 400;

    --tw-text-opacity: 1;

    color: rgb(149 149 149 / var(--tw-text-opacity, 1))
}
.ZxtDfwpmjg3bH3NnJNJv {

    border-radius: 5px
}

.f8U3RnNwumDhzutmLIpi {

    margin-top: 1rem;

    display: flex;

    cursor: pointer;

    align-items: center;

    justify-content: center;

    gap: 0.25rem;

    text-align: center;

    font-family: Noto Sans;

    font-size: 14px;

    --tw-text-opacity: 1;

    color: rgb(3 120 209 / var(--tw-text-opacity, 1))
}
`, "",{"version":3,"sources":["webpack://./src/components/common/SuccessModal/success.module.css"],"names":[],"mappings":"AACE;;IAAA,aAAsE;;IAAtE,sBAAsE;;IAAtE,mBAAsE;;IAAtE,uBAAsE;;IAAtE,SAAsE;;IAAtE,eAAsE;;IAAtE;AAAsE;;AAItE;;IAAA,aAA0B;;IAA1B;AAA0B;;AAI1B;;IAAA,gBAA8D;;IAA9D,sBAA8D;;IAA9D,eAA8D;;IAA9D,gBAA8D;;IAA9D,oBAA8D;;IAA9D;AAA8D;;AAI9D;;IAAA,sBAA6D;;IAA7D,eAA6D;;IAA7D,gBAA6D;;IAA7D,oBAA6D;;IAA7D;AAA6D;AAG7D;;IAAA;AAAoB;;AAIpB;;IAAA,gBAA+G;;IAA/G,aAA+G;;IAA/G,eAA+G;;IAA/G,mBAA+G;;IAA/G,uBAA+G;;IAA/G,YAA+G;;IAA/G,kBAA+G;;IAA/G,sBAA+G;;IAA/G,eAA+G;;IAA/G,oBAA+G;;IAA/G;AAA+G","sourcesContent":[".successWrapper {\n  @apply flex flex-col items-center justify-center text-center gap-4 p-6;\n}\n\n.successIcon {\n  @apply w-[165px] h-[165px];\n}\n\n.successTitle {\n  @apply text-[20px] font-semibold text-gray-700 font-inter mt-4;\n}\n\n.successDescription {\n  @apply text-gray-300 font-inter text-button font-dashboardSub;\n}\n.modalBorderRedious {\n  @apply rounded-[5px];\n}\n\n.footer {\n  @apply text-body text-primary mt-4 font-inter flex items-center justify-center text-center gap-1 cursor-pointer;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"successWrapper": `soqtGqqqvTTw6WLCQ6ow`,
	"successIcon": `kwP0PCUwBfWaMCUTojfT`,
	"successTitle": `KiBYUGfbraDxoQDYsylb`,
	"successDescription": `uMZDLazix2oFGedLw5QB`,
	"modalBorderRedious": `ZxtDfwpmjg3bH3NnJNJv`,
	"footer": `f8U3RnNwumDhzutmLIpi`
};
export default ___CSS_LOADER_EXPORT___;
